export default __webpack_public_path__ + "static/media/Island-1-05.5cdedcb7.svg";